import React from 'react';
import { JoraEmployerHelmet } from '@common/components/Helmet';
import {
  BackToJobsLink,
  WhatHappensNextInfo
} from '@common/componentsV2/Caja/components';
import { useRedirectUnauthenticatedUser } from '@common/hooks/useRedirectUnauthenticatedUser';
import { useTranslation } from '@common/hooks/useTranslation';
import { useCurrentUser } from '@common/hooks/user';
import { HeaderInfo } from './HeaderInfo';

export const EditJobSuccess = () => {
  useRedirectUnauthenticatedUser();
  const { t } = useTranslation();
  const { email } = useCurrentUser();

  return (
    <div className="flex flex-col gap-md mb-md">
      <JoraEmployerHelmet title={t('editJobSuccessPage.title')} />
      <HeaderInfo />
      <WhatHappensNextInfo emailAddress={email!} />
      <BackToJobsLink />
    </div>
  );
};
